import { getSignalingSocket } from 'services/signaling';

export const trackVirtualBackgroundApplied = (provider: string): void => {
  getSignalingSocket().send({
    event: 'virtualBackgroundApplied',
    data: { provider },
  });
};

export const trackVirtualBackgroundRemoved = (): void => {
  getSignalingSocket().send({ event: 'virtualBackgroundRemoved' });
};
